import { render, staticRenderFns } from "./roster-sync-page.vue?vue&type=template&id=7d68aec3&scoped=true&"
import script from "./roster-sync-page.ts?vue&type=script&lang=ts&"
export * from "./roster-sync-page.ts?vue&type=script&lang=ts&"
import style0 from "./roster-sync-page.scss?vue&type=style&index=0&id=7d68aec3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d68aec3",
  null
  
)

export default component.exports